import type { Job } from '../types/job';

export function formatEmploymentType(value?: string | null) {
  if (!value) {
    return "-";
  }

  const normalizedValue = value.trim().toUpperCase();

  switch (normalizedValue) {
    case "FULL_TIME":
      return "Full Time";

    case "PART_TIME":
      return "Part Time";

    case "CONTRACT":
      return "Contract";

    case "INTERNSHIP":
      return "Internship";

    case "FREELANCE":
      return "Freelance";

    default:
      return value
        .trim()
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
  }
}

export const formatWorkplaceType = (type: string) => {
  switch (type) {
    case "ONSITE":
      return "Onsite";
    case "REMOTE":
      return "Remote";
    case "HYBRID":
      return "Hybrid";
    default:
      return type;
  }
};

export const formatSalary = (job: Job) => {
  if (!job.minimumSalary || !job.maximumSalary) {
    return 'Not Disclosed';
  }

  const min = Number(job.minimumSalary) / 100000;
  const max = Number(job.maximumSalary) / 100000;

  return `₹${min}-${max} LPA`;
};

export const formatExperience = (job: Job) => {
  if (job.maximumExperience) {
    return `${job.minimumExperience}-${job.maximumExperience} Years`;
  }

  return `${job.minimumExperience}+ Years`;
};

export const getPostedDate = (createdAt: string) => {
  const created = new Date(createdAt);
  const today = new Date();

  const diff = Math.floor((today.getTime() - created.getTime()) / (1000 * 60 * 60 * 24));

  if (diff === 0) return 'Today';
  if (diff === 1) return '1 day ago';

  return `${diff} days ago`;
};

export const getDeadline = (applicationDeadline: string | null) => {
  if (!applicationDeadline) {
    return 'No Deadline';
  }

  const deadline = new Date(applicationDeadline);
  const today = new Date();

  const diff = Math.ceil((deadline.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

  if (diff < 0) {
    return 'Application Closed';
  }

  if (diff === 0) {
    return 'Closes Today';
  }

  if (diff === 1) {
    return 'Closes Tomorrow';
  }

  return `Closes in ${diff} days`;
};
